<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-if="!loading" class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl ">
                    Availability
                </div>
            </div>
            <div>
                <p>Please check below that your current availability is accurate. The more boxes you check off, the greater
                    chance that a team member will be able to find a schedule or additional shifts for you.</p>
                <div class="form">
                    <ValidationObserver ref="form">
                        <div class="row">
                            <div
                                class="col-12 text-right"
                            >
                                <div class="text-14">
                                    <b>Last updated:</b>
                                    {{ calculateDate(dataFormAvailability.updated_at ?? dataFormAvailability.created_at) }}
                                </div>
                            </div>

                            <AvailabilityForm
                                @data-changed="updateForm"
                                :user="userInfo"
                                class="col-lg-12"
                            ></AvailabilityForm>

                            <div class="col-12">
                                <p>
                                    <b>NOTE:</b> this is NOT the place to make time off requests for events or call out for
                                    a shift. To request a temporary time off, please go to the Support tab or make a Time
                                    Off Request Report or call the office 305-945-5022.
                                </p>
                            </div>
                            <div class="col-12">
                                <div class="btns-wrap">
                                    <button
                                        @click="reloadPage"
                                        class="btn btn--outline-primary w-100 w-sm-auto"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        @click="save"
                                        class="btn btn--secondary w-100 w-sm-auto"
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AvailabilityForm from "../CommonForms/AvailabilityForm.vue";
import EmployeeInfoService from "../services/EmployeeInfoService";
import ModalHandler from "../../../../../../resources/js/mixins/ModalHandler";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";

export default {
    name: 'EmployeeAvailability',
    components: {AvailabilityForm},
    mixins: [ModalHandler, DateConverter],
    props: {
        userInfo: {
            type: Object
        }
    },

    data() {
        return {
            loading: true,
            dataFormAvailability: {
                start_date: null,
                night: [],
                morning: [],
                afternoon: [],
                time_absence: null,
                updated_at: null,
            },
            formattedDate: null,
            userInfoLoaded: false

        }
    },

    methods: {
        save() {
            (async () => {
                this.$showLoadingMessage()
                const valid = await this.$refs.form.validate();

                if (!valid) {
                    this.$showErrorMessage();
                    return;
                }
                try {
                    const response = await EmployeeInfoService.updateAvailabilityForm(this.userInfo.id, this.dataFormAvailability);
                    if (response.status === 200) {
                        this.$showSuccessMessage();
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000)
                    }
                } catch (error) {
                    this.$handleErrors(error)
                }
            })();
        },
        setData() {
            Object.assign(this.dataFormAvailability, this.userInfo.availability);
            this.loading = false
        },
        updateForm(dataAvailabilityForm) {
            this.dataFormAvailability = dataAvailabilityForm;
        }
    },
    mounted() {
        this.setData()
    }
}

</script>

<style scoped>

</style>
